import { vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    class: "form-control bg p-2 shadow fw-bold",
    type: "text",
    placeholder: "Search Dog breed",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.breed) = $event)),
    onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getBreed && _ctx.getBreed(...args)), ["enter"]))
  }, null, 544)), [
    [
      _vModelText,
      _ctx.breed,
      void 0,
      { trim: true }
    ]
  ])
}